import LoansList from "./loans-list/LoansList";

export default function MyLoans() {
  return (
      <LoansList />
  );
}
